import styled from 'styled-components';

import theme from '../../utils/theme';

const { colors, typography } = theme;

export const StyledLabel = styled.p<{ $subText?: string }>`
	font-size: 17px;
	color: ${colors.black[500]};
	font-family: ${typography.roboto};
	margin: 0px;
	margin-bottom: ${(props) => (props.$subText ? '0px' : '15px')};
`;

export const StyledSubLabel = styled.p`
	font-size: 12px;
	color: ${colors.black[700]};
	font-family: ${typography.roboto};
	margin: 0px;
	margin-bottom: 15px;
`;
